/*
  TS cart: one row for a split item (B56, 2026-10-30).
  Shopify's buy X get Y gift discounts ("Free gift at $X") can split one item over two cart lines: with a gift in the
  cart, 4 trailer wheels became a line of 1 and a line of 3, because Shopify marks the fewest units that reach the
  gift's amount. The cart page (sections/ts-main-cart.liquid) and the slide-out cart (snippets/ts-cart-drawer.liquid)
  show such lines as one row with the total quantity and price; the row's quantity box and Remove link carry
  data-ts-keys with the key of every line in it.

  The + and - buttons still go through theme.js on the row's first line (one more or one less on that line). This file
  handles the two things that must change every line of the row: typing a quantity (all of it goes on the first line,
  the others are set to 0) and Remove (every line set to 0). Shopify may split the lines again afterwards; the row
  shows them together again. Then the cart page reloads, as theme.js does after a quantity change, and the slide-out
  cart is redrawn through the theme's "cart:refresh".
*/
(function () {
  if (window.tsCartLines) return;
  window.tsCartLines = true;

  var cartUrl = (window.routes && window.routes.cartUrl) || '/cart';

  function keysOf(el) {
    return (el.getAttribute('data-ts-keys') || '').split(',').filter(Boolean);
  }

  function apply(keys, total) {
    if (!keys.length) return;
    var updates = {};
    keys.forEach(function (key, i) { updates[key] = i === 0 ? total : 0; });
    document.dispatchEvent(new CustomEvent('theme:loading:start'));
    fetch(cartUrl + '/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ updates: updates })
    }).catch(function () {}).then(function () {
      if (window.theme && window.theme.pageType === 'cart') {
        window.location.reload();
        return;
      }
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { scrollToTop: false } }));
    });
  }

  // Typed quantity: caught on the way down, before theme.js (which would put the whole number on the first line only).
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t.matches || !t.matches('input[data-ts-keys]')) return;
    e.stopImmediatePropagation();
    var total = parseInt(t.value, 10);
    if (isNaN(total) || total < 0) total = 0;
    apply(keysOf(t), total);
  }, true);

  // Remove: the link has no data-action, so theme.js leaves it alone.
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('a[data-ts-keys]');
    if (!link) return;
    e.preventDefault();
    apply(keysOf(link), 0);
  });
})();
